import { makeStyles } from '@material-ui/core';
import { DSTheme } from '../../../styles/themes/types';

export const useProfileStyles = makeStyles((theme: DSTheme) => ({
  subtitle: {
    marginTop: '8px',
    color: theme.palette.text.navigation,
  },
  container: {
    display: 'grid',
    gridGap: '32px',
  },
  button: {
    width: '173px',
  },
  select: {
    '& .MuiSelect-select:focus': {
      backgroundColor: 'inherit',
    },

    '& fieldset': {
      borderColor: theme.palette.text.primary,
      borderRadius: '16px',
    },

    '& label': {
      transform: 'translate(15px, -5.5px) scale(0.75)',
      color: theme.palette.text.primary,
    },
  },
  imageWrapper: {
    width: '175px',
  },
  uploadCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'space-between',
    borderRadius: '16px',
    backgroundColor: theme.palette.background.elevation1,
    padding: '32px',
    marginTop: '8px',
    width: '110px',
    height: '85px',
    outline: 'none',

    '&.image': {
      padding: '16px',
      border: '1px solid',
      borderColor: theme.palette.text.primary,
      width: '142px',
      height: '117px',

      '& img': {
        width: '100%',
        height: '100%',
      },
    },

    '&.dashed': {
      border: '1px dashed',
      borderColor: theme.palette.text.primary,
    },
  },
  selectRow: {
    display: 'grid',
    gridGap: '32px',
    gridTemplateColumns: '248px 248px',

    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '266px 266px',
    },
  },
}));
